import { Nullable } from "@tager/admin-services";
import { OptionType, SingleFileInputValueType } from "@tager/admin-ui";

import { BrandType, FullSpecialType } from "@/typings/model";
import {
  SpecialCreationPayload,
  SpecialUpdatePayload,
} from "@/services/requests";
import { createFileInputValue } from "@/utils/common";

export type FormValues = {
  name: string;
  urlAlias: string;
  content: string;
  image: Nullable<SingleFileInputValueType>;
  pageDescription: string;
  openGraphImage: Nullable<SingleFileInputValueType>;
  pageTitle: string;
};

export function convertSpecialToFormValues(
  special: Nullable<FullSpecialType>
): FormValues {
  if (!special) {
    return {
      name: "",
      urlAlias: "",
      content: "",
      image: null,
      pageDescription: "",
      openGraphImage: null,
      pageTitle: "",
    };
  }

  return {
    name: special.name ?? "",
    urlAlias: special.urlAlias ?? "",
    content: special.content ?? "",
    image: special.image ? createFileInputValue(special.image) : null,
    pageDescription: special.pageDescription ?? "",
    openGraphImage: special.openGraphImage
      ? createFileInputValue(special.openGraphImage)
      : null,
    pageTitle: special.pageTitle ?? "",
  };
}

export function convertFormValuesToSpecialCreationPayload(
  values: FormValues
): SpecialCreationPayload {
  return {
    name: values.name ?? "",
    content: values.content ?? "",
    image: values.image?.file.id ?? null,
    pageDescription: values.pageDescription ?? "",
    openGraphImage: values.openGraphImage?.file.id ?? null,
    pageTitle: values.pageTitle ?? "",
  };
}

export function convertFormValuesToSpecialUpdatePayload(
  values: FormValues
): SpecialUpdatePayload {
  return {
    urlAlias: values.urlAlias ?? "",
    ...convertFormValuesToSpecialCreationPayload(values),
  };
}
